import { resolveRouteAccess } from '@/config/route-access';
import type { AuthUser } from '../types';
import { hasAnyPermission, isSuperAdmin } from './permissions';

/**
 * Whether this account can actually open `path` — the check behind every
 * link, row action and redirect that leaves the current screen.
 *
 * Unknown paths return `true` on purpose: this gates *affordances*, and a
 * missing registry entry must never hide a working button. Route coverage is
 * enforced separately by `tests/unit/route-access.test.ts`, which fails when a
 * dashboard page has no rule.
 */
export function canAccessRoute(
  user: AuthUser | null,
  path: string,
  settings: Record<string, unknown> = {}
): boolean {
  if (!user) return false;
  if (isSuperAdmin(user)) return true;

  const rule = resolveRouteAccess(path);
  if (!rule) return true;
  if (rule.featureFlag && !settings[rule.featureFlag]) return false;
  if (rule.permissions.length === 0) return true;

  return hasAnyPermission(user, [...rule.permissions]);
}
